import { MGPOptional } from '@everyboard/lib';
import { BoardValue } from '../../jscaip/AI/BoardValue';
import { Orthogonal } from '../../jscaip/Orthogonal';
import { TaflPawn } from './TaflPawn';
import { TaflPieceAndControlHeuristic } from './TaflPieceAndControlHeuristic';
export class TaflEscapeThenPieceThenControlHeuristic extends TaflPieceAndControlHeuristic {
    getBoardValue(node, config) {
        const metrics = this.getControlScoreAndPieceScores(node, config);
        const stepForEscape = this.getStepForEscapeMetric(node.gameState);
        return BoardValue.multiMetric([
            stepForEscape,
            metrics.safeScore,
            metrics.threatenedScore,
            metrics.controlScore,
        ]);
    }
    getStepForEscapeMetric(state) {
        const defender = state.getPieceAt(this.rules.getKingCoord(state).get()).getOwner();
        const stepForEscape = this.getStepForEscape(state) * defender.getScoreModifier();
        if (stepForEscape === -1) {
            return BoardValue.getPreVictoryValueOf(defender.getOpponent());
        }
        else {
            return -1 * stepForEscape;
        }
    }
    getStepForEscape(state) {
        const king = this.rules.getKingCoord(state).get();
        return this._getStepForEscape(state, 1, [king], []).getOrElse(-1);
    }
    _getStepForEscape(state, step, previousGen, handledCoords) {
        const nextGen = this.getNextGen(state, previousGen, handledCoords);
        if (nextGen.length === 0) {
            // not found:
            return MGPOptional.empty();
        }
        if (nextGen.some((coord) => state.isExternalThrone(coord))) {
            return MGPOptional.of(step);
        }
        else {
            step++;
            handledCoords.push(...nextGen);
            return this._getStepForEscape(state, step, nextGen, handledCoords);
        }
    }
    getNextGen(state, previousGen, handledCoords) {
        const newGen = [];
        for (const piece of previousGen) {
            for (const dir of Orthogonal.ORTHOGONALS) {
                let landing = piece.getNext(dir, 1);
                while (state.hasPieceAt(landing, TaflPawn.UNOCCUPIED)) {
                    if (handledCoords.every((coord) => coord.equals(landing) === false)) {
                        // coord is new
                        newGen.push(landing);
                    }
                    landing = landing.getNext(dir, 1);
                }
            }
        }
        return newGen;
    }
}
